import type { ComputedRef } from 'vue';
import { computed, inject } from 'vue';
import { baseTheme } from '../theme';

export const injectionKey = Symbol('theme');

export const useTheme = () => {
  const injectedTheme = inject<ComputedRef<typeof baseTheme> | undefined>(
    injectionKey,
    undefined,
  );
  const theme = computed(() => injectedTheme?.value ?? baseTheme);
  return theme;
};
